import { Assets } from 'pixi.js'
import { bundles } from '../config/assets'
import { GlobalState } from '../config/globalState'

export function preloadAssets(onComplete: () => void): void {
  Object.entries(bundles).forEach(([name, assets]) => Assets.addBundle(name, assets))

  Assets.loadBundle(Object.keys(bundles), (progress: number) => {})
    .then((resources: any) => {
      onComplete()
    })
    .catch((err) => {
      console.error('[preloadAssets] Failed to load bundles:', err)
      onComplete()
    })
}
